import { useAddFormulaFunctionIfRequired } from '@modules/quantify/hooks/useAddFormulaFunctionIfRequired';
import { useAddOrderFunctionIfRequired } from '@modules/quantify/hooks/useAddOrderFunctionIfRequired';
import { EQLFunction } from 'v2/core/repository/eql/types';
import { useAddApplyTaxonomyFunctionIfRequired } from '../../useAddApplyTaxonomyFunctionIfRequired';
import { useAddPaginationFunctionIfRequired } from './useAddPaginationFunctionIfRequired';
import { useAddSearchBucketsFunctionIfRequired } from './useAddSearchBucketsFunctionIfRequired';

interface GetQuantifyTableEQLFunctionsOptions {
  shouldSkipPaginateFunction?: boolean;
  shouldSkipSearchFunction?: boolean;
  shouldFetchCount?: boolean;
}

export const useGetQuantifyTableEQLFunctions = ({
  shouldSkipPaginateFunction = false,
  shouldSkipSearchFunction = false,
  shouldFetchCount,
}: GetQuantifyTableEQLFunctionsOptions = {}) => {
  const functions: EQLFunction[] = [];

  const addApplyTaxonomyFunctionIfRequired =
    useAddApplyTaxonomyFunctionIfRequired();
  const addFormulaFunctionIfRequired = useAddFormulaFunctionIfRequired({
    shouldFetchCount,
    variant: 'table',
  });
  const addOrderFunctionIfRequired = useAddOrderFunctionIfRequired();
  const addSearchBucketsFunctionIfRequired =
    useAddSearchBucketsFunctionIfRequired();
  const addPaginationFunctionIfRequired = useAddPaginationFunctionIfRequired();

  addApplyTaxonomyFunctionIfRequired(functions);
  addFormulaFunctionIfRequired(functions);
  addOrderFunctionIfRequired(functions);

  if (!shouldSkipSearchFunction) {
    addSearchBucketsFunctionIfRequired(functions);
  }

  // Avoid applying pagination limit when statically selecting rows, as it's not suitable for TK+Categories.
  if (!shouldSkipPaginateFunction) {
    addPaginationFunctionIfRequired(functions);
  }

  return functions;
};
